import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Toolbar,
  AppBar,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Chip,
  Checkbox,
  ListItemText,
  MenuItem,
  Box,
  Snackbar,
  Alert,
} from "@mui/material";
import Atras from "./atras";
import { updateUser, auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { SKILLS_OPTIONS } from "./login";

const Edit = () => {
  const [user, setUser] = useState(null);
  const [userType, setUserType] = useState(null);
  const [displayName, setDisplayName] = useState("");
  const [phone, setPhone] = useState("");
  const [point, setPoint] = useState("");
  const [skills, setSkills] = useState([]);
  const [bio, setBio] = useState("");
  const [website, setWebsite] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [github, setGithub] = useState("");
  const [loading, setLoading] = useState(true);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      setUser(authUser);
      if (authUser) {
        const userDoc = await getDoc(doc(db, "users", authUser.uid));
        if (userDoc.exists()) {
          const data = userDoc.data();
          setDisplayName(data.displayName || "");
          setPhone(data.phone || "");
          setPoint(data.point || "");
          setSkills(Array.isArray(data.skills) ? data.skills : []);
          setBio(data.bio || "");
          setWebsite(data.portfolioLinks?.website || "");
          setLinkedin(data.portfolioLinks?.linkedin || "");
          setGithub(data.portfolioLinks?.github || "");
          setUserType(data.userType || null);
        }
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleSkillsChange = (event) => {
    const { value } = event.target;
    setSkills(typeof value === "string" ? value.split(",") : value);
  };

  const handleSubmit = async () => {
    if (!user) return;
    await updateUser(user.uid, {
      displayName,
      phone,
      point,
      bio,
      ...(userType === "freelancer" && {
        skills,
        portfolioLinks: { website, linkedin, github },
      }),
    });
    setSaved(true);
  };

  return (
    <Container>
      <AppBar position="fixed">
        <Toolbar
          sx={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Atras color="inherit" />
          <Container style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
            <Typography variant="h5" gutterBottom>
              Editar perfil
            </Typography>
          </Container>
        </Toolbar>
      </AppBar>

      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          width: "100%",
          textAlign: "left",
          marginTop: "140px",
        }}
      >
        <TextField
          label="Nombre"
          variant="outlined"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          fullWidth
          margin="normal"
          disabled={loading}
        />
        <TextField
          label="Teléfono"
          variant="outlined"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          fullWidth
          margin="normal"
          disabled={loading}
        />
        <TextField
          label="Localidad"
          variant="outlined"
          value={point}
          onChange={(e) => setPoint(e.target.value)}
          fullWidth
          margin="normal"
          disabled={loading}
        />
        <TextField
          label={userType === "freelancer" ? "Bio (contá tu experiencia)" : "Bio"}
          variant="outlined"
          value={bio}
          onChange={(e) => setBio(e.target.value)}
          fullWidth
          multiline
          rows={3}
          margin="normal"
          disabled={loading}
        />
        {userType === "freelancer" && (
          <>
            <FormControl fullWidth sx={{ mt: 2, mb: 1 }} disabled={loading}>
              <InputLabel id="edit-skills-label">Habilidades</InputLabel>
              <Select
                labelId="edit-skills-label"
                label="Habilidades"
                multiple
                value={skills}
                onChange={handleSkillsChange}
                input={<OutlinedInput label="Habilidades" />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} size="small" />
                    ))}
                  </Box>
                )}
              >
                {SKILLS_OPTIONS.map((option) => (
                  <MenuItem key={option} value={option}>
                    <Checkbox checked={skills.indexOf(option) > -1} />
                    <ListItemText primary={option} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Sitio web / portfolio"
              variant="outlined"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
              fullWidth
              margin="normal"
              disabled={loading}
            />
            <TextField
              label="LinkedIn"
              variant="outlined"
              value={linkedin}
              onChange={(e) => setLinkedin(e.target.value)}
              fullWidth
              margin="normal"
              disabled={loading}
            />
            <TextField
              label="GitHub"
              variant="outlined"
              value={github}
              onChange={(e) => setGithub(e.target.value)}
              fullWidth
              margin="normal"
              disabled={loading}
            />
          </>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
          sx={{ mt: 2, mb: 4 }}
        >
          Guardar cambios
        </Button>
      </Container>
      <Snackbar open={saved} autoHideDuration={3000} onClose={() => setSaved(false)}>
        <Alert severity="success" onClose={() => setSaved(false)}>
          Perfil actualizado correctamente.
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Edit;
